export default __webpack_public_path__ + "static/dbrankin-560a2c3908c2412f18c74b6b67132c70.jpg";